import React, { Component } from "react";
import {
  Typography,
  CircularProgress,
  Button,
  Box,
  Checkbox
} from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MUIDataTable from "mui-datatables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { getDatafromApi, handleCallApi } from "./calls";
import { ApiData } from "./config";

class PopularDestinations extends Component {
  state = {
    tableData: [],
    loading: false,
    openDeleteCnfrm: false,
    selectedRows: [], // 👈 MANUAL SELECTION
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    this.setState({ loading: true });
    const data = await getDatafromApi(
      ApiData.baseURL + "/trips/most-popular?all_platforms=true"
    );

const sortedData = data.slice().sort((a, b) => {
  const orderA = a.most_popular_order ?? Infinity;
  const orderB = b.most_popular_order ?? Infinity;

  return orderA - orderB;
});

    this.setState({ tableData: sortedData, loading: false });
  };

  /* ===================== CHECKBOX LOGIC ===================== */
  toggleRow = (index) => {
    const selected = [...this.state.selectedRows];

    if (selected.includes(index)) {
      this.setState({
        selectedRows: selected.filter((i) => i !== index),
      });
    } else {
      this.setState({
        selectedRows: [...selected, index],
      });
    }
  };

  toggleSelectAll = () => {
    if (this.state.selectedRows.length === this.state.tableData.length) {
      this.setState({ selectedRows: [] });
    } else {
      this.setState({
        selectedRows: this.state.tableData.map((_, i) => i),
      });
    }
  };

  /* ===================== DELETE ===================== */
  handleDelete11 = async () => {
    const data = [...this.state.tableData];
    // eslint-disable-next-line no-unused-vars
    const _selected = [...this.state.selectedRows].sort((a, b) => b - a);

   /*  for (let index of selected) {
      await handleCallApi(
        "DELETE",
        ApiData.baseURL + `/trips/${data[index].id}`
      );
      data.splice(index, 1);
    } */

    toast.success("Selected destinations deleted");
    this.setState({
      tableData: data,
      selectedRows: [],
      openDeleteCnfrm: false,
    });
  };

  handleDelete = async () => {
  const data = [...this.state.tableData];
  const selected = [...this.state.selectedRows].sort((a, b) => b - a);

  try {
    for (let index of selected) {
      const trip = data[index];

      // ✅ FULL OBJECT + mostPopular false
      const payload = {
        ...trip,
        days: Array.isArray(trip.days)
          ? trip.days.map((d) => d.id)
          : [],

        mostPopular: false,
      };

      await handleCallApi(
        "PUT",
        `https://api.planyourtrip.com/backend/v1/vg/trips/${trip.id}/`,
        payload
      );

      // ✅ UI se remove
      data.splice(index, 1);
    }

    toast.success("Selected destinations removed from Most Popular");

    this.setState({
      tableData: data,
      selectedRows: [],
      openDeleteCnfrm: false,
    });
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong while updating trips");
  }
};

  
  /* ===================== DRAG ===================== */
onDragEnd = async (result) => {
  if (!result.destination) return;

  const items = Array.from(this.state.tableData);
  const [moved] = items.splice(result.source.index, 1);
  items.splice(result.destination.index, 0, moved);

  // ✅ UPDATE TABLE
  this.setState({ tableData: items });

  // ✅ BUILD PAYLOAD (ID + ORDER)
  const payload = {
    orders: items.map((item, index) => ({
      id: item.id,
      order: index + 1,
    })),
  };


  // ✅ API CALL
  await handleCallApi(
    "POST",
    ApiData.baseURL + "/trips/reorder-popular",
    payload
  );
};




  render() {
    const columns = [
      { name: "", label: "" }, // checkbox
      { name: "", label: "" }, // drag
      { name: "id", label: "ID" },
      { name: "name", label: "Name" },
      { name: "internal_name", label: "Internal Name" },
      { name: "country", label: "Country" },
    ];

    const options = {
      selectableRows: "none", // ❌ disable mui default
      download: false,
      print: false,
      filter: false,
      pagination: false,
      viewColumns: false,
      customRowRender: (_, dataIndex) => {
        const row = this.state.tableData[dataIndex];


        if (!row) return null;
        const isChecked = this.state.selectedRows.includes(dataIndex);

        return (
          <Draggable draggableId={String(row.id)} index={dataIndex}>
            {(provided) => (
              <tr
                ref={provided.innerRef}
                {...provided.draggableProps}
                style={{
                  ...provided.draggableProps.style,
                  height: 56,
                }}
              >
                {/* ✅ CHECKBOX */}
                <td style={{ width: 50 }}>
                  <Checkbox
                    checked={isChecked}
                    onChange={() => this.toggleRow(dataIndex)}
                    color="primary"
                  />
                </td>

                {/* ☰ DRAG HANDLE */}
                <td
                  {...provided.dragHandleProps}
                  style={{
                    cursor: "grab",
                    width: 40,
                    fontSize: 18,
                    textAlign: "center",
                  }}
                >
                  ☰
                </td>

                <td>{row.id}</td>
                <td>{row.name}</td>
                <td>{row.internal_name}</td>
                <td>{row.country}</td>
              </tr>
            )}
          </Draggable>
        );
      },
      customTableHeadRender: () => (
        <thead>
          <tr>
            <th style={{ width: 50 }}>
              <Checkbox
                checked={
                  this.state.selectedRows.length ===
                  this.state.tableData.length
                }
                indeterminate={
                  this.state.selectedRows.length > 0 &&
                  this.state.selectedRows.length <
                    this.state.tableData.length
                }
                onChange={this.toggleSelectAll}
              />
            </th>
            <th style={{ width: 40 }}></th>
            <th>ID</th>
            <th>Name</th>
            <th>Internal Name</th>
            <th>Country</th>
          </tr>
        </thead>
      ),
    };

    return (
      <Box p={3}>
        <ToastContainer />

        {/* HEADER */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h5">Popular Destinations</Typography>

          <Button
            variant="contained"
            color="secondary"
            disabled={!this.state.selectedRows.length}
            onClick={() => this.setState({ openDeleteCnfrm: true })}
            
          >
            Remove Selected
          </Button>




        </Box>

        {this.state.loading && <CircularProgress />}

        {/* TABLE */}
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Droppable droppableId="table">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                <MUIDataTable
                  data={this.state.tableData}
                  columns={columns}
                  options={options}
                />
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

        {/* DELETE CONFIRM */}
        <Dialog
          open={this.state.openDeleteCnfrm}
          onClose={() => this.setState({ openDeleteCnfrm: false })}
        >
          <DialogTitle>Remove</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to remove selected Most Populor Trips?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.setState({ openDeleteCnfrm: false })}>
              Cancel
            </Button>
            <Button color="secondary" onClick={this.handleDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

export default PopularDestinations;
